if (!customElements.get('mega-menu-panel')) {
  class MegaMenuPanel extends HTMLElement {
    constructor() {
      super();
      this.hoverDelay = 120;
      this.hoverTimer = null;
    }

    connectedCallback() {
      this.triggers = Array.from(this.querySelectorAll('[data-mega-trigger]'));
      if (!this.triggers.length) return;

      this.defaultIndex = this.triggers[0].dataset.megaTrigger;

      this.triggers.forEach((trigger) => {
        trigger.addEventListener('mouseenter', () => this.scheduleActivate(trigger.dataset.megaTrigger));
        trigger.addEventListener('mouseleave', () => this.cancelActivate());
        trigger.addEventListener('focus', () => this.activate(trigger.dataset.megaTrigger));
      });

      this.details = this.closest('details');
      if (this.details) {
        this.details.addEventListener('toggle', () => {
          if (this.details.open) this.activate(this.defaultIndex);
        });
      }
    }

    scheduleActivate(index) {
      this.cancelActivate();
      this.hoverTimer = setTimeout(() => this.activate(index), this.hoverDelay);
    }

    cancelActivate() {
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer);
        this.hoverTimer = null;
      }
    }

    activate(index) {
      if (!index) return;

      this.triggers.forEach((trigger) => {
        trigger.classList.toggle('is-active', trigger.dataset.megaTrigger === index);
      });

      this.querySelectorAll('[data-mega-pane]').forEach((pane) => {
        pane.hidden = pane.dataset.megaPane !== index;
      });

      const groups = Array.from(this.querySelectorAll('[data-mega-media]'));
      const match = groups.find((group) => group.dataset.megaMedia === index);
      const fallback = groups.find((group) => group.dataset.megaMedia === 'default');
      const visible = match || fallback || null;
      groups.forEach((group) => {
        group.hidden = group !== visible;
      });
    }

    openForBlock(blockElement) {
      const group = blockElement.closest('[data-mega-media]');
      if (this.details) this.details.setAttribute('open', '');
      if (!group) return;
      const index = group.dataset.megaMedia;
      if (index === 'default') {
        this.triggers.forEach((trigger) => trigger.classList.remove('is-active'));
        this.querySelectorAll('[data-mega-pane]').forEach((pane) => (pane.hidden = true));
        this.querySelectorAll('[data-mega-media]').forEach((item) => (item.hidden = item !== group));
      } else {
        this.activate(index);
      }
    }
  }

  customElements.define('mega-menu-panel', MegaMenuPanel);

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:block:select', (event) => {
      const card = event.target.closest('[data-mega-block]') || event.target.querySelector('[data-mega-block]');
      if (!card) return;
      const panel = card.closest('mega-menu-panel');
      if (panel) panel.openForBlock(card);
    });

    document.addEventListener('shopify:block:deselect', (event) => {
      const card = event.target.closest('[data-mega-block]') || event.target.querySelector('[data-mega-block]');
      if (!card) return;
      const details = card.closest('details');
      if (details) details.removeAttribute('open');
    });
  }
}
